var m = require('mithril');
var layout = require('../layout/layout');
var events = require('./events');

routes = {
  '/events': {
    view: function() {
      return m(layout, m(events));
    },
  }
}


module.exports = routes;